import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const propertiesValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const errors: ValidationErrors = {};
  const methodOfFeedAdministration = control.get('methodOfFeedAdministration');
  const lengthOfFeedGutterInMeters = control.get('lengthOfFeedGutterInMeters');
  const numberOfFeedPans = control.get('numberOfFeedPans');

  if (methodOfFeedAdministration.value === 'Chain') {
    if (lengthOfFeedGutterInMeters.value === null) {
      errors['chainValue'] = true;
    }
  } else if (methodOfFeedAdministration.value === 'Pan') {
    if (numberOfFeedPans.value === null) {
      errors['panValue'] = true;
    }
  }

  const waterSupply = control.get('waterSupply');
  const numberOfWaterNipples = control.get('numberOfWaterNipples');
  const numberOfDrinkingTowers = control.get('numberOfDrinkingTowers');

  if (waterSupply.value === 'WaterNipples') {
    if (numberOfWaterNipples.value === null) {
      errors['waterNipples'] = true;
    }
  } else if (waterSupply.value === 'DrinkingTowers') {
    if (numberOfDrinkingTowers.value === null) {
      errors['drinkingTowers'] = true;
    }
  } else if (waterSupply.value === 'Both') {
    if (numberOfWaterNipples.value === null) {
      errors['waterNipples'] = true;
    }
    if (numberOfDrinkingTowers.value === null) {
      errors['drinkingTowers'] = true;
    }
  }

  return errors;
};
